import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

export default function DashboardHead() {
  useEffect(() => {
    // Load dashboard CSS files dynamically
    const loadCSS = (href) => {
      // Check if link already exists
      const existingLink = document.querySelector(`link[href="${href}"]`);
      if (existingLink) return existingLink;

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
      return link;
    };

    // Load dashboard JS files dynamically
    const loadJS = (src, id) => {
      // Check if script already exists
      const existingScript = document.getElementById(id);
      if (existingScript) return existingScript;

      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    };

    // Load CSS files
    const cssFiles = [
      'assets/vendors/core/core.css',
      'assets/vendors/bootstrap-datepicker/bootstrap-datepicker.min.css',
      'assets/fonts/feather-font/css/iconfont.css',
      'assets/css/style.css',
    ];

    // Load JS files
    const jsFiles = [
      { src: 'assets/vendors/core/core.js', id: 'dashboard-core-js' },
      { src: 'assets/vendors/chartjs/Chart.min.js', id: 'dashboard-chartjs-js' },
      { src: 'assets/vendors/jquery.flot/jquery.flot.js', id: 'dashboard-flot-js' },
      { src: 'assets/vendors/jquery.flot/jquery.flot.resize.js', id: 'dashboard-flot-resize-js' },
      { src: 'assets/vendors/bootstrap-datepicker/bootstrap-datepicker.min.js', id: 'dashboard-datepicker-js' },
      { src: 'assets/vendors/apexcharts/apexcharts.min.js', id: 'dashboard-apexcharts-js' },
      { src: 'assets/vendors/feather-icons/feather.min.js', id: 'dashboard-feather-js' },
      { src: 'assets/js/template.js', id: 'dashboard-template-js' },
      { src: 'assets/js/dashboard-light.js', id: 'dashboard-light-js' },
      { src: 'assets/js/datepicker.js', id: 'dashboard-datepicker-custom-js' },
    ];

    // Load all CSS
    const loadedCSS = cssFiles.map((href) => loadCSS(href));

    // Load JS files sequentially
    let jsIndex = 0;
    const loadNextJS = () => {
      if (jsIndex < jsFiles.length) {
        const file = jsFiles[jsIndex];
        const script = loadJS(file.src, file.id);
        script.onload = () => {
          jsIndex++;
          loadNextJS();
        };
        script.onerror = () => {
          jsIndex++;
          loadNextJS();
        };
      } else {
        // Initialize feather icons after all scripts are loaded
        if (window.feather) {
          window.feather.replace();
        }
      }
    };
    loadNextJS();

    // Cleanup function to remove dashboard scripts when navigating away
    return () => {
      // Remove dashboard scripts when component unmounts (navigating away from dashboard)
      jsFiles.forEach((file) => {
        const script = document.getElementById(file.id);
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      // Remove dashboard CSS
      cssFiles.forEach((href) => {
        const link = document.querySelector(`link[href="${href}"]`);
        if (link && link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
    };
  }, []);

  return (
    <Helmet>
      <title>Travelin - Dashboard</title>
      <meta name="description" content="Travelin Responsive HTML Admin Dashboard Template based on Bootstrap 5" />
      <meta name="author" content="Travelin" />
      
      {/* Dashboard Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
}
